import { create } from 'zustand'

export const useContentStore = create((set) => ({
  content: {},
  setContent: (content) => set(() => {
    return {content};
  }),
}))
